import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import Typography from '../Typography';
import Button from '../Button/Button';

const TimeFilterModal = ({
  tempTimeFilter,
  setTempTimeFilter,
  handleApplyTime,
  handleCancelTime,
  tFilter,
  timeDropdownRef
}) => {
  return (
    <TimeDropdown ref={timeDropdownRef}>
      <TimeOptionsBlock>
        <Typography as="label" $variant="body-1-medium" color={theme.colors.defaultStrong}>
          {tFilter('timeFilters.time.label')}
        </Typography>

        <RadioGroup>
          {['flexible', 'today', 'tomorrow', 'this_week', 'this_month'].map((option) => (
            <RadioOption key={option}>
              <RadioInput
                type="radio"
                id={`time-${option}`}
                name="timeFilter"
                value={option}
                checked={tempTimeFilter === option}
                onChange={() => setTempTimeFilter(option)}
              />
              <RadioLabel htmlFor={`time-${option}`} $variant="body-2-medium" color={theme.colors.defaultStrong}>
                {tFilter(`timeFilters.time.${option}`)}
              </RadioLabel>
            </RadioOption>
          ))}
        </RadioGroup>
      </TimeOptionsBlock>

      <TimeDropdownButtons>
        <Button type="button" id="applyTimeButton" size="l" onClick={handleApplyTime}>
          {tFilter('buttons.apply')}
        </Button>
        <Button type="button" id="cancelTimeButton" size="l" $variant="ghost" onClick={handleCancelTime}>
          {tFilter('buttons.cancel')}
        </Button>
      </TimeDropdownButtons>
    </TimeDropdown>
  );
};

export default TimeFilterModal;

const TimeDropdown = styled.div`
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  border-radius: ${({ theme }) => theme.radius.xs};
  box-shadow: 0 0 4px 0 rgb(0 0 0 / 8%), 0 4px 8px 0 rgb(0 0 0 / 8%);
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.md};
  padding: ${({ theme }) => theme.sizing.sm};
  position: absolute;
  right: 0;
  top: ${({ theme }) => theme.sizing.xxl};
  width: 320px;
  z-index: 999;
`;

const TimeOptionsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const RadioOption = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const RadioInput = styled.input`
  appearance: none;
  border: 2px solid ${({ theme }) => theme.border.defaultWeak};
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  margin: 0;
  position: relative;
  width: 20px;
  
  &:checked {
    border-color: ${({ theme }) => theme.colors.brandMain};
    
    &::after {
      background-color: ${({ theme }) => theme.colors.brandMain};
      border-radius: 50%;
      content: '';
      height: 10px;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
    }
  }
`;

// const RadioLabel = styled.label`
//   font-family: "MonaSans", sans-serif;
//   font-size: 16px;
//   cursor: pointer;
// `;

const RadioLabel = styled(Typography)``;

const TimeDropdownButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.xs};
  justify-content: flex-start;
`;